module.exports = __webpack_public_path__ + "6e4a9679e65cc320746c3e5d48e51f28.ttf";